import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import AuditForm from "@/pages/AuditForm";
import AuditResult from "@/pages/AuditResult";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import RoiCalculator from "@/pages/RoiCalculator";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/audit" element={<AuditForm />} />
        <Route path="/audit/result/:auditId" element={<AuditResult />} />
        <Route path="/roi" element={<RoiCalculator />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
      </Routes>
      <Toaster richColors position="top-center" />
    </BrowserRouter>
  );
}
